import { KmPerAu } from "../../AstroConstants.js";
import { CachedOrbit } from "./CachedOrbit.js";
import { Vector3 } from "../../../math/Vector3.js";
export class VSOPSeries {
    terms;
    constructor(terms) {
        this.terms = terms;
    }
}
const sumVSOPSeries = (series, t) => {
    if (series.terms.length < 1)
        return 0.0;
    let x = 0.0;
    const term = series.terms;
    for (let i = 0; i < term.length / 3; i++)
        x += term[3 * i] * Math.cos(term[3 * i + 1] + term[3 * i + 2] * t);
    return x;
};
export class VSOP87Orbit extends CachedOrbit {
    vsL;
    vsB;
    vsR;
    period;
    boundingRadius;
    constructor(_vsL, _vsB, _vsR, _period, _boundingRadius) {
        super();
        this.vsL = _vsL;
        this.vsB = _vsB;
        this.vsR = _vsR;
        this.period = _period;
        this.boundingRadius = _boundingRadius;
    }
    getPeriod() {
        return this.period;
    }
    getBoundingRadius() {
        return this.boundingRadius;
    }
    computePosition(jd) {
        // t is Julian millenia since J2000.0
        const t = (jd - 2451545.0) / 365250.0;
        // Heliocentric coordinates
        let l = 0.0;
        // longitude
        let b = 0.0;
        // latitude
        let r = 0.0;
        // radius
        let i;
        let T;
        // Evaluate series for l
        T = 1;
        for (i = 0; i < this.vsL.length; i++) {
            l += sumVSOPSeries(this.vsL[i], t) * T;
            T = t * T;
        }
        // Evaluate series for b
        T = 1;
        for (i = 0; i < this.vsB.length; i++) {
            b += sumVSOPSeries(this.vsB[i], t) * T;
            T = t * T;
        }
        // Evaluate series for r
        T = 1;
        for (i = 0; i < this.vsR.length; i++) {
            r += sumVSOPSeries(this.vsR[i], t) * T;
            T = t * T;
        }
        /*
                    // l and b are in units of 1e+8 radians
                    l *= 1.0e-8;
                    b *= 1.0e-8;
                    // r is in units of 1e-8 AU
                    r *= (KM_PER_AU / 100000000.0);
             */
        r *= KmPerAu;
        // Corrections for internal coordinate system
        b -= Math.PI / 2;
        l += Math.PI;
        const vector = new Vector3(Math.cos(l) * Math.sin(b) * r, Math.cos(b) * r, -Math.sin(l) * Math.sin(b) * r);
        return vector;
    }
}
